import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";

const navItems = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Skills", id: "skills" },
  { label: "Experience", id: "experience" },
  { label: "Education", id: "education" },
  { label: "Projects", id: "projects" },
  { label: "Instructor", id: "instructor" },
  { label: "Certifications", id: "certifications" },
  { label: "Awards", id: "awards" },
  { label: "Contact", id: "contact" },
];

const FloatingNavbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const mobileMain = navItems.slice(0, 5);
  const mobileMore = navItems.slice(5);

  // 🔹 Close menu when scrolling
  useEffect(() => {
    const handleScroll = () => {
      if (menuOpen) setMenuOpen(false);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [menuOpen]);

  return (
    <motion.div
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="fixed top-5 left-0 w-full flex justify-center z-50 px-3"
    >
      <div className="relative">

        {/* Navbar */}
        <div className="backdrop-blur-xl bg-white/10 border border-white/20 shadow-xl rounded-full px-5 py-3">

          {/* Desktop */}
          <div className="hidden md:flex items-center gap-6">
            {navItems.map((item, i) => (
              <a
                key={i}
                href={`#${item.id}`}
                className="text-sm font-medium text-white hover:text-cyan-400 transition"
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* Mobile */}
          <div className="flex md:hidden items-center gap-4">
            {mobileMain.map((item, i) => (
              <a
                key={i}
                href={`#${item.id}`}
                className="text-xs font-medium text-white hover:text-cyan-400 transition"
              >
                {item.label}
              </a>
            ))}

            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="text-white text-sm hover:text-cyan-400 transition"
            >
              ☰
            </button>
          </div>

        </div>

        {/* Mobile Dropdown */}
        <AnimatePresence>
          {menuOpen && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 12 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.2 }}
              className="absolute right-0 mt-3 backdrop-blur-xl bg-white/10 border border-white/20 rounded-xl shadow-xl p-4 flex flex-col gap-3"
            >
              {mobileMore.map((item, i) => (
                <a
                  key={i}
                  href={`#${item.id}`}
                  onClick={() => setMenuOpen(false)}
                  className="text-sm text-white hover:text-cyan-400 transition"
                >
                  {item.label}
                </a>
              ))}
            </motion.div>
          )}
        </AnimatePresence>

      </div>
    </motion.div>
  );
};

export default FloatingNavbar;